import { appStore } from '../../app/AppStore';
import { bindDisplaySettingsScopeToReduxAndSetInitialValues } from '../../app/content/DisplaySettingsReduxBindings';
import { bindDisplaySettingsScopeToUrlAndSetInitialValues } from '../../app/content/DisplaySettingsUrlBindings';
import { IMainScope } from '../../app/IMainScope';
import { getQueryStringServiceFromAngular } from '../../common/react/QueryString';
import { AngularContextFactory } from '../factories/AngularContextFactory';
import { Module } from '../Module';
import { DataSources } from '../resources/Datasources';
import { TelemetryService } from '../services/TelemetryService';
import { TopBarService } from '../services/TopBarService';

export class MainCtrl {

  public static $inject = [
    '$scope',
    '$location',
    'TopBarService',
    'AngularContextFactory',
    'TelemetryService',
    'DataSources'
  ];

  constructor($scope: IMainScope,
              $location: ng.ILocationService,
              TopBarService: TopBarService,
              angularContextFactory: AngularContextFactory,
              telemetryService: TelemetryService,
              datasourcesResource: DataSources) {

    $scope.topBarSettings = TopBarService.TopBarSettings;

    const angularContext = angularContextFactory.create($scope);
    $scope.pageHeaderProps = {
      angularContext,
      telemetryService,
      datasourcesResource
    };
    $scope.leftNavProps = {
      telemetryService
    };

    const queryString = getQueryStringServiceFromAngular($location);
    bindDisplaySettingsScopeToReduxAndSetInitialValues($scope, appStore);
    bindDisplaySettingsScopeToUrlAndSetInitialValues($scope, appStore, queryString);
  }
}

Module.instance().controller('MainCtrl', MainCtrl);
